import { useQuery } from "react-query";
import { useForm } from "react-hook-form";
import { client } from "shared/helpers/client";
import { OrderState } from "shared/helpers/constants";
import { OrderCard } from "shared/helpers/models";
import qs from "qs";

interface OrderResponse {
  data: OrderCard[];
  pageNumber: number;
  pageSize: number;
  totalCount: number;
}

export function useCustomerOrders(orderStatus: number[]) {
  // Filters Form
  const methods = useForm({
    defaultValues: {
      Status: orderStatus,
    },
  });

  const filters = methods.watch();

  // const { data: orders } = useQuery(["customer-orders", filters], () =>
  //   client<OrderResponse>("/orders/getCustomerOrders", {
  //     params: filters,
  //     paramsSerializer: qs.stringify,
  //   }).then((r) => r.response)
  // );

  return {
    OrderState
  };
}
